import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { DEFAULT_APP_CONFIG } from '@config/app.config';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TitleService extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private translateService: TranslateService
  ) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const baseTitle = DEFAULT_APP_CONFIG.appName;

    const newTitle = this.buildTitle(snapshot);

    if (newTitle) {
      const translateTitle = this.translateService.instant(newTitle);
      this.title.setTitle(`${translateTitle} - ${baseTitle}`);
    } else {
      this.title.setTitle(`${baseTitle}`);
    }
  }
}
